export default "__VITE_ASSET__mLZDcdb7__"